export enum AnnualReportTemplate {
  ViGuideYearlyReport = 'ViGuideYearlyReport',
  RemoteServiceViessmann = 'RemoteServiceViessmann',
}
